import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalPricingDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useBatteryProposalPricing(
  proposalId: string | undefined,
): UseQueryResult<BatteryProposalPricingDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.pricing(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getPricing(proposalId)
    },
    enabled: Boolean(proposalId),
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
